<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: white;">
      <NavBar styleType="finance"></NavBar>
      <div ref="videoContainerEmpty" id="videoContainerEmpty" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
        <div id="videoContent" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
          <div id="bkgrdVideoOverlay" :style="{ height: videoHeight + 'px' }"></div>
        </div>
      </div>
      <div class="body-overall page-top fonts" style="color:black!important;">
          <v-row class="textPanel">
              <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs pb-6">
                    <v-col cols="12" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">ABOUT</h1>
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0 pb-6">
                        <h1 class="font2-heada" style="color:black!important;">ABOUT</h1>
                  </v-row>
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
              </div>
          </v-row>  
      </div>
      
      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel">
                <div class="container">
                  <v-row justify="start" class="pl-12 pr-12 pb-4 pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                              42Monks Capital is a privately held firm focused on quantitative trading strategies. 
                              We are committed to developing a world-class quantitative investment platform through our systematic, diversified approach. 
                              Our team of experienced professionals combines deep market knowledge with cutting-edge technology to identify and capitalize on market inefficiencies across various asset classes.                              
                              The firm has developed proprietary, state-of-the-art systems that enable rapid development of investment ideas to live trading strategies.
                              We serve a global clientele, including hedge funds, family offices, and high-net-worth individuals.
                        </span>
                      </v-row>  
                </div>
            </v-row>
      </div>

      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-6">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">PRODUCTS</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                            We develop a few products beyond quantitative trading, including a platform for family offices
                             with access to our knowledge system, and a wealth-management platform that helps track flows across different asset classes.
                        </span>
                      </v-row>               
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">PRODUCTS</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-0 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                            We develop a few products beyond quantitative trading, including a platform for family offices
                             with access to our knowledge system, and a wealth-management platform that helps track flows across different asset classes.
                        </span>
                      </v-row>  
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-16">
                <div class="full-container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-down">
                    <v-col cols="12" class="pa-0 ma-0 pr-4 pt-4">                  
                      <h1 class="font3-heada" style="color:black!important;">"AI driven strategies are the future. We build MCP data driven strategies. No intuition, no emotions, we mix data with technology. 
                        We are constantly testing new models that are capable of adapting to changing market conditions."</h1>
                                 
                        <v-row>
                          <v-col cols="10">                          
                            <v-row justify="end"> 
                              <v-avatar size="170" justify="end" class="mr-3 mt-6">
                                <v-img :src="require('@/assets/images/avatar.webp')"></v-img>
                              </v-avatar>
                            </v-row>
                          </v-col>
                          <v-col cols="2" class="pa-0 ma-0 pt-8">
                            <v-row class="pt-6">
                              <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall" style="color:black!important;">
                                Tomasz Andel
                              </span>
                            </v-row>
                            <v-row>
                              <span class="mt-0 pb-0 mb-0 pt-1 fonts-xsmall2" style="color:black!important;">
                                  Quant at 42Monks
                              </span>
                            </v-row>
                          </v-col>
                        </v-row>
                    </v-col>
                  </v-row>         

                  <v-row justify="start" class="pl-12 pr-12 hidden-md-and-up pt-8 mt-0">
                        <h1 class="font3-heada" style="color:black!important;">"AI driven strategies are the future. We build MCP data driven strategies. No intuition, no emotions, we mix data with technology. 
                        We are constantly testing new models that are capable of adapting to changing market conditions."</h1>
                  </v-row>

                  <v-row class="hidden-md-and-up mb-0 pb-0">
                          <v-col cols="6">                          
                            <v-row justify="end" class="mb-0 pb-0"> 
                              <v-avatar size="120" justify="end" class="mr-3 mt-6">
                                <v-img :src="require('@/assets/images/avatar.webp')"></v-img>
                              </v-avatar>
                            </v-row>
                          </v-col>
                          <v-col cols="6" class="pa-0 ma-0 pt-8">
                            <v-row class="pt-1">
                              <span class="mt-0 pb-0 mb-0 pt-6 fonts-xsmall" style="color:black!important;">
                                Tomasz Andel
                              </span>
                            </v-row>
                            <v-row>
                              <span class="mt-0 pb-0 mb-0 pt-1 fonts-xsmall2" style="color:black!important;">
                                  Quant at 42Monks
                              </span>
                            </v-row>
                          </v-col>
                  </v-row>
                </div>
            </v-row>
      </div>
            <div class="body-overall page-top page-bottom fonts pt-0 mt-0" style="color:black!important;">
              <v-row class="textPanel pb-2">
                  <div class="container">
                    <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                    <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>

                    <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                      <v-col cols="12" justify="start" class="pa-0 ma-0">  
                        <v-row class="pl-6 pt-8">
                          <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                            We are privately held and independent, building generational wealth for us and our partners.
                            <br/><br/>
                            With offices in Monaco and Warsaw we serve a global clientele, leveraging our strategic locations to access key capital and talent pools especially from Eastern Europe.
                          </span>
                        </v-row>                
                      </v-col>
                    </v-row>
                    <v-row justify="start" class="pl-12 pr-12 pt-6 hidden-sm-and-up pt-0 mt-0">
                          <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                            We are privately held and independent, building generational wealth for us and our partners.
                            <br/><br/>
                            With offices in Monaco and Warsaw we serve a global clientele, leveraging our strategic locations to access key capital and talent pools especially from Eastern Europe.
                          </span> 
                    </v-row>  
                  </div>
              </v-row>
            </div>
                <v-row class="textPanel page-top pb-0 pt-4">
                  <div class="full-container">
                    <v-img  style="opacity: 1" :src="require('@/assets/images/about_mc3.webp')"></v-img>
                  </div>
                </v-row>
      <div class="body-overall fonts">
        <v-row class="textPanel pb-0">
          <v-divider class="divider ml-9 mr-9 hidden-xs mt-14" style="color: black!important;"></v-divider>
          <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up mt-14" style="color: black!important;"></v-divider>
        </v-row>
      </div>
      <div class="body-overall fonts">
          <Footer typed="finance"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './NavBar'
import Footer from './Footer'

export default {
  name: 'About',
  props: ['drawerham'],

  components: {
    NavBar,
    Footer
  },
  data: () => ({
    videoHeight: 1000 // Initial height of the video
  }),
  mounted() {  
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
  },
  computed: {

  },  
  created() {

  }, 
  methods: {
    handleScroll() {
      if (!this.drawerham){
        // Get the current scroll position
        const scrollPosition = Math.round(window.scrollY || window.pageYOffset);
        // Calculate the new height for the video
        const newVideoHeight = Math.round(Math.max(500, 1000 - scrollPosition));
        // Update the video height
        this.videoHeight = newVideoHeight;
      }
    },
    handleClickVideo(link){
      if (link === 'Log'){
        window.open('https://selene.42monks.com/','_blank');
      }  else if (link === 'Office'){
        window.open('https://office.42monks.com/','_blank');
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

#videoContainerEmpty {
  position: relative;
  box-sizing: border-box;
  max-height: 100px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 100px;
  transition: height 0.10s linear;
}

.full-container {
  background-color: white !important;
    width: 100%!important;
    max-width: 100%!important;
    margin-right: auto!important;
    margin-left: auto!important;

  @media (min-width: 600px) {
    width: 100%!important;
  }

  @media (min-width: 1280px) {
    width: 1625px!important;
  }
}


#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100px;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 5;
  transition: height 0.10s linear;
}

.body-overall {
  background-color: white !important;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}

.nomenu-btn-page {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}


.nomenu-btn-link {
  color: black;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 0; /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1; /* Show the underline when hovering */
}


</style>

